// helpers/webauthn.js
//
// Minimal native WebAuthn (FIDO2) browser glue — replaces @simplewebauthn/
// browser (which this old CRA's webpack can't transpile from node_modules).
// Produces exactly the RegistrationResponseJSON / AuthenticationResponseJSON
// shapes that @simplewebauthn/server (backend) expects.

function b64urlToBuf(s) {
  const pad = "=".repeat((4 - (s.length % 4)) % 4);
  const b64 = (s + pad).replace(/-/g, "+").replace(/_/g, "/");
  const bin = atob(b64);
  const buf = new Uint8Array(bin.length);
  for (let i = 0; i < bin.length; i++) buf[i] = bin.charCodeAt(i);
  return buf;
}
function bufToB64url(buf) {
  const bytes = new Uint8Array(buf);
  let bin = "";
  for (let i = 0; i < bytes.length; i++) bin += String.fromCharCode(bytes[i]);
  return btoa(bin).replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");
}

export async function startRegistration(options) {
  const pk = { ...options };
  pk.challenge = b64urlToBuf(options.challenge);
  pk.user = { ...options.user, id: b64urlToBuf(options.user.id) };
  if (Array.isArray(options.excludeCredentials)) {
    pk.excludeCredentials = options.excludeCredentials.map((c) => ({ ...c, id: b64urlToBuf(c.id) }));
  }
  const cred = await navigator.credentials.create({ publicKey: pk });
  return {
    id: cred.id,
    rawId: bufToB64url(cred.rawId),
    type: cred.type,
    response: {
      clientDataJSON: bufToB64url(cred.response.clientDataJSON),
      attestationObject: bufToB64url(cred.response.attestationObject),
      transports: cred.response.getTransports ? cred.response.getTransports() : [],
    },
    clientExtensionResults: cred.getClientExtensionResults ? cred.getClientExtensionResults() : {},
  };
}

export async function startAuthentication(options) {
  const pk = { ...options };
  pk.challenge = b64urlToBuf(options.challenge);
  if (Array.isArray(options.allowCredentials)) {
    pk.allowCredentials = options.allowCredentials.map((c) => ({ ...c, id: b64urlToBuf(c.id) }));
  }
  const cred = await navigator.credentials.get({ publicKey: pk });
  const r = cred.response;
  return {
    id: cred.id,
    rawId: bufToB64url(cred.rawId),
    type: cred.type,
    response: {
      clientDataJSON: bufToB64url(r.clientDataJSON),
      authenticatorData: bufToB64url(r.authenticatorData),
      signature: bufToB64url(r.signature),
      userHandle: r.userHandle ? bufToB64url(r.userHandle) : undefined,
    },
    clientExtensionResults: cred.getClientExtensionResults ? cred.getClientExtensionResults() : {},
  };
}
